import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/development-documents/$id/_layout/tickets/')({});